import React from 'react';
import { App } from '../types/app';
import { iconMap, AppsIcon } from './icons';
import './AppCard.css';

interface AppCardProps {
  app: App;
}

export const AppCard: React.FC<AppCardProps> = ({ app }) => {
  const IconComponent = iconMap[app.icon] || AppsIcon;

  const handleClick = () => {
    window.open(app.url, '_blank');
  };

  return (
    <div className={`app-card ${app.status}`} onClick={handleClick}>
      <div className="app-card-icon">
        <IconComponent size={32} color="#111827" />
      </div>
      <div className="app-card-content">
        <h3 className="app-card-title">{app.name}</h3>
        <p className="app-card-description">{app.description}</p>
      </div>
    </div>
  );
};
